import { ApplyNewService } from '@/services/applyNew.service';
import { defineComponent } from 'vue';
import ApplyBanner from './components/ApplyBannerNew.vue';
import ApplyForm from './components/ApplyFormNew.vue';
import { useService, declareProviders } from '@kaokei/use-vue-service';
import { useRoute } from 'vue-router';
export default defineComponent({
  name: 'ItemApply',
  components: {
    ApplyBanner: ApplyBanner,
    ApplyForm: ApplyForm
  },
  setup: function () {
    declareProviders([ApplyNewService]);
    var route = useRoute();
    var params = route.params;
    var itemId = +params.id;
    var applyService = useService(ApplyNewService);
    applyService.setItemId(itemId);
    var isEdit = route.query.userExamId ? 1 : 0;
    applyService.getContestInfo(isEdit);
    return {
      applyService: applyService
    };
  }
});